// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

/**
 * We are expanding orderLines to make sure order.canAddAllToCart is accurate (will only be when orderLines are loaded)
 * because we want to disable reorder (from OrderHistoryTable.tsx) in scenarios where order.canAddAllToCart is false.
 */
addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter = { ...props.apiParameter, expand: ["orderLines"] };
});
